import { toast } from 'react-toastify';

export function handleRequestError(defaultMessage?: string) {
  const message = defaultMessage ?? 'Error on fetch service';

  toast.error(message);
}
